import styles from './style.m.less';

export default function NotificationsDotInline() {
    return <span className={styles.dot}></span>;
}
